import React, { useEffect, useState } from "react";
// import background from "../../assets/background.png";
import AuthBanner from "../../assets/auth_banner.png";
import { Form, FormGroup, Input, Button, Spinner, Container, Breadcrumb, BreadcrumbItem, Label } from "reactstrap";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardBackspace, MdOutlineNavigateNext } from "react-icons/md";
import { authForgot } from "../../Shared/validation";
import "./authentication.scss";
import { forgotPassword } from "../../services/auth.service";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GoHome } from "react-icons/go";
import Footer from "../../layout/Footer";

const ForgotPassword = () => {
	const [errors, setErrors] = useState({});
	const [LoginClick, setLoginClick] = useState(false);
	const [values, setValues] = useState({
		email: '',
	});

	useEffect(() => {
		setTimeout(() => {
			window?.scrollTo({ top: 0, behavior: 'smooth' })
		}, 0)
	}, []);


	var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

	const handleChange = (e) => {
		const newData = { ...values };
		newData[e?.target?.id] = e?.target?.value?.trim()?.replace(regex, '');
		errors[e?.target?.id] = null;
		setValues(newData);
	}

	const isDiasabled = () => {
		if (LoginClick === true) {
			return true
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault();
		const errors = await authForgot(values);
		setErrors(errors);
		if (errors === null) {
			setErrors({})
			setLoginClick(true)
			try {
				const response = await forgotPassword({
					username: values?.email
				});
				if (response?.status === 200) {
					toast.success("We have send reset password link to your entered email address.", {
						position: toast.POSITION.TOP_RIGHT,
						autoClose: 2000
					})
					setLoginClick(false)
				}
				else {
					toast.error("No account exists linked to the entered Email", {
						position: toast.POSITION.TOP_RIGHT,
						autoClose: 2000,
					});
					setLoginClick(false)
				}
			} catch (err) {
				let error_message = "No account exists linked to the entered Email";
				if (err?.response && err?.response?.data && err?.response?.data?.message) {
					error_message = err?.response?.data?.message;
				}
				toast.error(error_message, {
					position: toast.POSITION.TOP_RIGHT,
					autoClose: 2000,
				});
				setLoginClick(false)
			}
		}
	}

	return (
		<section>
		<Container>
		<Breadcrumb className="nt-breadcrumb">
          <Link to="/" className="breadcrumb_item1">
            <GoHome className="home_icon" />
          </Link>
          <span className="breadcrumb-divider">
            <MdOutlineNavigateNext />
          </span>
          <BreadcrumbItem active>
            <Link to="/forgot-password" className="nt-breadcrumb_item2">
              Forgot Password
            </Link>
          </BreadcrumbItem>
        </Breadcrumb>
		<div className="signin_section forgotpassword">
			<div className="signin_container">
			<div className="Leftsection">
				<img src={AuthBanner} alt="" />
			</div>
			<div className="Rightsection">
				<Form className="signinform" onSubmit={handleSubmit}>
					<h3>Forgot Password</h3>
					<span> Please enter your Email ID. You will receive an email with instructions on how to reset your password.
					</span>
					<div className="form_section">
						<FormGroup>
							<Label>Email*</Label>
							<Input
								id="email"
								name="email"
								autoComplete="off"
								value={values?.email}
								onChange={handleChange}
								placeholder="Enter Your Email ID"
								autoCapitalize="none"
								type="text"
							/>
							<span className="error">
								{errors?.email &&
									errors?.email}
							</span>
						</FormGroup>
						<Button type="submit" disabled={isDiasabled()} >
							{LoginClick === true ? <Spinner size="sm"></Spinner> : "Send Link"}
						</Button>
						<div className="no_account">
							<Link to="/sign-in" className="back_login forgotpassword">
								<MdOutlineKeyboardBackspace size={23} />
								<span>Back to Login</span>
							</Link>
						</div>
					</div>
				</Form>
			</div>
			</div>
		</div>
		</Container>
		<Footer/>
		</section>
	);
};

export default ForgotPassword;